import { AxiosResponse } from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { ISelectType } from "@4uhub/lib4uhub";

// Carrega a lista completa assim que `baseParams` está definido e refaz a busca com `searchBy`
// quando o componente de seleção envia o texto digitado (ele só envia a partir de 3 letras).
// `baseParams` precisa ter referência estável; com `null` a lista fica vazia (campo desabilitado).
export const useSearchableOptions = (
  fetchOptions: (params: Record<string, unknown>) => Promise<AxiosResponse<ISelectType[]>>,
  baseParams: Record<string, unknown> | null,
) => {
  const [options, setOptions] = useState<ISelectType[]>([]);
  const lastRequest = useRef(0);

  const request = useCallback(
    async (search?: { searchBy?: string }) => {
      const requestId = ++lastRequest.current;
      const response = await fetchOptions({
        ...baseParams,
        ...(search?.searchBy ? { searchBy: search.searchBy } : {}),
      });
      // Ignora respostas antigas (ex.: tipo trocado durante a busca)
      if (requestId === lastRequest.current) setOptions(response.data);
      return response;
    },
    [fetchOptions, baseParams],
  );

  useEffect(() => {
    if (!baseParams) {
      lastRequest.current++;
      setOptions([]);
      return;
    }
    request().catch(() => setOptions([]));
  }, [baseParams, request]);

  const searchParams = useCallback((searchBy: string) => ({ searchBy }), []);

  return { options, request, searchParams };
};
